<template>
  <div class="reviewBody">
    <div class="reviewBodyTitleBox">
      <div class="titleText">
        <div>
          <i class="el-icon-arrow-left" @click="goback"></i>
        </div>
        <div>北京体育馆</div>
      </div>
      <div class="titlebtnBox">
        <el-button type="danger" icon="el-icon-close">拒绝</el-button>
        <el-button type="primary">
          <i class="el-icon-check"></i>
          审批通过
        </el-button>
      </div>
    </div>
    <div class="mytitleBox">
      <div class="title">场馆介绍</div>
      <div class="title">世界级体育场馆</div>
      <div class="dcsbox">北京体育馆是一个多功能体育场馆，可容纳超过18,000名观众。它曾举办过许多重要的国际赛事。</div>
      <div class="dcsbox">·现代化设施</div>
      <div class="dcsbox">·多种运动项目</div>
      <div class="dcsbox">·优质观赛体验</div>
    </div>
    <div class="timeBox">
      <div class="left">
        <div class="disBox">
          <i class="el-icon-s-help" style=" font-size: 30px;"></i>开放时间
        </div>
        <div class="disBox2">周一至周五 9:00-22:00，周末10:00-23:00</div>
      </div>
      <div class="right">
        <div class="disBox">
          <i class="el-icon-s-home" style=" font-size: 30px;"></i>场馆地址
        </div>
        <div class="disBox2">北京市朝阳区体育馆路1号</div>
      </div>
    </div>
    <div class="telBox">
      <div class="disBox">
        <i class="el-icon-phone" style=" font-size: 30px;"></i>联系方式
      </div>
      <div class="disBox2">电话:010-12345678，邮箱:info@beijingsportscenter.com</div>
    </div>
    <div class="telBox">
      <div class="disBox">
        <i class="el-icon-s-order" style=" font-size: 30px;"></i>审批状态
      </div>
      <div class="disBox2">
        <el-tag type="warning" effect="dark">待审核</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goback() {
      this.$router.push("/");
    }
  }
};
</script>

<style>
.reviewBody {
  height: 100%;
  width: 100%;
  /* background-color: red; */
  /* padding: ; */
}
.mytitleBox {
  height: 250px;
  width: 100%;
  /* background-color: aqua; */
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.reviewBodyTitleBox {
  height: 50px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  /* background-color: aqua; */
  line-height: 50px;
}
.titleText {
  font-weight: 800;
  font-size: 25px;
  width: 200px;
  display: flex;
  justify-content: space-between;
}
.titlebtnBox {
  width: 300px;
  height: 50px;
}
.mytitleBox .title {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 20px;
}
.mytitleBox .dcsbox {
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 20px;
  color: rgb(146, 146, 146);
}
.timeBox {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  /* background-color: aqua; */
}
.timeBox .left {
  padding: 20px;
  width: 45%;
  height: 100%;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.timeBox .right {
  padding: 20px;
  width: 45%;
  height: 100%;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.timeBox .disBox {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 30px;
}
.timeBox .disBox2 {
  font-size: 16px;
}
.telBox {
  padding: 20px;
  width: 100%;
  height: 120px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.telBox .disBox {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 30px;
}
</style>